import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { generateServiceCode, changeServiceStatus, fetchService, createServiceRequest } from "store/actions";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import CustomSelect from "components/Common/custom-select";
import Select from "react-select";

const serviceDayOptions = [
  { label: "Day-1 Service", value: "1" },
  { label: "Day-2 Service", value: "2" },
];

const TimeSheetService = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  const {
    service,
    serviceCode,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    service: state.TimesheetSetupServiceReducer?.service ?? [],
    serviceCode: state.TimesheetSetupServiceReducer?.serviceCode ?? '',
    loading: state.TimesheetSetupServiceReducer?.loading,
    error: state.TimesheetSetupServiceReducer?.error,
    success: state.TimesheetSetupServiceReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchService(unitId));
    dispatch(generateServiceCode(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchService(authDetails?.unit_id));
      dispatch(generateServiceCode(authDetails?.unit_id));
      formik.resetForm();
      setIsEdit(false);
      setEditId(null);
    }
  }, [authDetails, success, dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
  }, [location]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      serviceCode: serviceCode,
      serviceName: "",
      serviceDay: "",
    },
    validationSchema: Yup.object({
      serviceCode: Yup.string().required("Service code is required"),
      serviceDay: Yup.string()
        .required("Service Type is required"),
      serviceName: Yup.string()
        .required("Service name is required")
        .max(50, "Service name must be at most 50 characters")
        .matches(
          /^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
          "Invalid characters used"
        )

    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("service_id", editId ? editId : 0);
      formData.append("service_code", values.serviceCode);
      formData.append("service_name", values.serviceName);
      formData.append("service_type", values.serviceDay);
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(createServiceRequest(formData))
    },

  });

  const handleEdit = (row) => {
    setEditId(row.service_id); // Set the ID to know we are editing
    let serviceTypeId = "";
    if (row.service_type === "Day-1 Service") serviceTypeId = "1";
    else if (row.service_type === "Day-2 Service") serviceTypeId = "2";

    formik.setValues({
      serviceCode: row.service_code,
      serviceName: row.service_name,
      serviceDay: serviceTypeId,
    });
  };


  const handleCancel = () => {
    setEditId(null); // Reset back to Save mode
    formik.resetForm();
  };

  const handleToggleStatus = (id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this service.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("service_id", id);
        formData.append("create_by", authDetails?.user_id);
        formData.append("unit_id", authDetails?.unit_id);
        dispatch(changeServiceStatus(formData));
      }
    });
  };

  const CustomSelect = ({
  closeMenuOnScroll = true,
  menuPortalTarget = document.body,
  menuPosition = "fixed",
  menuShouldScrollIntoView = false,
  ...props
}) => {
  return (
    <Select
      {...props}
      closeMenuOnScroll={closeMenuOnScroll}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
      menuShouldScrollIntoView={menuShouldScrollIntoView}
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};
 

  // const columns = [
  //   {
  //     Header: "Actions",
  //     headerClassName: 'text-center',
  //     className: 'text-center',
  //     Cell: (cellProps) => {
  //       const { b_active, service_id } = cellProps.row.original;
  //       const isActive = b_active === 1; // Status 1 = Active
  //       return (
  //         <div className="text-center">
  //           <Link to="#" className="text-success  me-2" onClick={() => handleEdit(cellProps.row.original)}>
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //           <Link to="#" className="me-2" style={{ color: isActive ? "green" : "red" }} onClick={() => handleToggleStatus(service_id, isActive)}>
  //             <i className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`} id={`status-tooltip-${cellProps.row.id}`} />
  //             <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
  //               {isActive ? "Mark Inactive" : "Mark Active"}
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   { Header: "S.No", Cell: ({ row }) => service.length - row.index, className: "serial-no text-center", applyHeaderClass: true, },
  //   { Header: "Service Code", accessor: "service_code" },
  //   { Header: "Service Name", accessor: "service_name" },
  //   { Header: "Created By", accessor: "create_by" },
  //   { Header: "Created On", accessor: "create_date" },
    
  // ];

  const columns = [
    {
      Header: "Actions",
      headerClassName: "text-center",
      className: "text-center",
      Cell: (cellProps) => {
        const { b_active, service_id } = cellProps.row.original;
        const isActive = b_active === 1;

        return (
          <div className="text-center">

            {/* ACTIVATE / DEACTIVATE */}
            {canDelete && (
              <Link
                to="#"
                className="me-2"
                style={{ color: isActive ? "green" : "red" }}
                onClick={() => handleToggleStatus(service_id, isActive)}
              >
                <i
                  className={`mdi ${
                    isActive ? "mdi-check-circle" : "mdi-close-circle"
                  } font-size-18`}
                  id={`status-tooltip-${cellProps.row.id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`status-tooltip-${cellProps.row.id}`}
                >
                  {isActive ? "Mark Inactive" : "Mark Active"}
                </UncontrolledTooltip>
              </Link>
            )}
            
            {/* EDIT */}
            {canEdit && (
              <Link
                to="#"
                className="text-success ms-2"
                onClick={() => handleEdit(cellProps.row.original)}
              >
                <i
                  className="bx bxs-edit font-size-18"
                  id={`edittooltip-${cellProps.row.id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`edittooltip-${cellProps.row.id}`}
                >
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}

            

          </div>
        );
      },
    },

    { 
      Header: "S.No", 
      Cell: ({ row }) => service.length - row.index,
      className: "serial-no text-center",
      applyHeaderClass: true,
    },
    { Header: "Service Code", accessor: "service_code" },
     { Header: "Service Type", accessor: "service_type" },
    { Header: "Service Name", accessor: "service_name" },
    { Header: "Created By", accessor: "create_by" },
    { Header: "Created On", accessor: "create_date" },
  ];

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Service Master" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col lg={2}>
                  <FormGroup>
                    <Label>Service Code</Label>
                    <Input
                      type="text"
                      name="serviceCode"
                      disabled
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.serviceCode}
                    />
                    {formik.touched.serviceCode && formik.errors.serviceCode && (
                      <div className="text-danger">{formik.errors.serviceCode}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>
                      Service Type <span className="text-danger">*</span>
                    </Label>

                    <CustomSelect
                      id="serviceDay"
                      name="serviceDay"
                      isMulti={false}
                      options={serviceDayOptions}
                       closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={
                        serviceDayOptions.find(
                          opt => opt.value === formik.values.serviceDay
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          "serviceDay",
                          selectedOption?.value || ""
                        )
                      }
                      onBlur={() =>
                        formik.setFieldTouched("serviceDay", true)
                      }
                    />

                    {formik.touched.serviceDay && formik.errors.serviceDay && (
                      <div className="text-danger">
                        {formik.errors.serviceDay}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={5}>
                  <FormGroup>
                    <Label>Service Name <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="serviceName"
                      maxLength={50}
                      value={formik.values.serviceName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Service Name"
                      className={formik.touched.serviceName && formik.errors.serviceName ? "is-invalid" : ""}
                    />
                    {formik.touched.serviceName && formik.errors.serviceName && (
                      <div className="text-danger">{formik.errors.serviceName}</div>
                    )}
                  </FormGroup>
                </Col>
                {/* <Col md="2" className="text-end col-lg-12">
                  <Button type="submit" color="primary" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {editId ? "Update" : "Save"}
                  </Button>

                  <Button type="button" className="btn button-cancel" onClick={handleCancel}> <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col> */}
                <Col className="d-flex mob-center align-items-center justify-content-end mt-2">

                   {canCreate && (
                      <Button type="submit" color="primary" className="btn button-save me-2">
                        <i className="fas fa-save me-1" /> {editId ? "Update" : "Save"}
                      </Button>
                    )}
                    <Button type="button" className="btn button-cancel me-2" onClick={handleCancel}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer columns={columns} data={service} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimeSheetService;
